import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageContext from "./LanguageContext";
import { initialLanguage, LANGUAGE_STORAGE_KEY, localizedPath, stripLanguage, translate } from "./language";

export default function LanguageProvider({ children, defaultLanguage = "id" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [language, setLanguage] = useState(() => initialLanguage(location.pathname, defaultLanguage));

  useEffect(() => {
    document.documentElement.lang = language;
    try { window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language); } catch { /* Language remains usable without storage. */ }
    const path = localizedPath(location.pathname, language);
    if (path !== location.pathname) navigate(`${path}${location.search}${location.hash}`, { replace: true });
  }, [language, location.pathname, location.search, location.hash, navigate]);

  const value = useMemo(() => ({
    language,
    setLanguage,
    t: text => translate(text, language),
    href: path => localizedPath(path, language),
    basePath: stripLanguage(location.pathname).replace(/\/+$/, "") || "/",
  }), [language, location.pathname]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
